module.exports = __webpack_public_path__ + "static/media/Collections-Outdoor-Experiences-Desktop.04d2e16a.jpg";